const modelRTL = {
  health: true,
  pension: false,
  workingInSpace: true,
  food: false,
  allAround: true,
}

export default modelRTL
